import '../front-ui/js/hs.core'
import '../front-ui/js/hs.circles'

$(document).on('ready', function () {
    // initialization of circles
    $('.js-circle').each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
    });
});
